/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '../completed.component.scss.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../app/completed/ebit-banner/completed.ebit-banner.component';
import * as i3 from 'ng2-device-detector';
const styles_CompletedEbitBannerComponent:any[] = [i0.styles];
export const RenderType_CompletedEbitBannerComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:2,
    styles:styles_CompletedEbitBannerComponent,data:{}});
export function View_CompletedEbitBannerComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),0,'a',[['id','bannerEbit']],
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i1.ɵted(-1,(null as any),['\n'])),(_l()(),i1.ɵeld(2,0,(null as any),(null as any),
      0,'param',[['id','ebitParam']],[[8,'value',0]],(null as any),(null as any),(null as any),
      (null as any)))],(null as any),(_ck,_v) => {
    var _co:i2.CompletedEbitBannerComponent = _v.component;
    const currVal_0:any = i1.ɵinlineInterpolate(1,'',_co.paramValue,'');
    _ck(_v,2,0,currVal_0);
  });
}
export function View_CompletedEbitBannerComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'completed-ebit-banner',
      ([] as any[]),(null as any),(null as any),(null as any),View_CompletedEbitBannerComponent_0,
      RenderType_CompletedEbitBannerComponent)),i1.ɵdid(1,4308992,(null as any),0,
      i2.CompletedEbitBannerComponent,[i3.Ng2DeviceService],(null as any),(null as any))],
      (_ck,_v) => {
        _ck(_v,1,0);
      },(null as any));
}
export const CompletedEbitBannerComponentNgFactory:i1.ComponentFactory<i2.CompletedEbitBannerComponent> = i1.ɵccf('completed-ebit-banner',
    i2.CompletedEbitBannerComponent,View_CompletedEbitBannerComponent_Host_0,{ebitStoreId:'ebitStoreId',
        offerable:'offerable'},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2NvZGVidWlsZC9vdXRwdXQvc3JjNTYwNTk5NjQ0L3NyYy9zcmMvYXBwL2NvbXBsZXRlZC9lYml0LWJhbm5lci9jb21wbGV0ZWQuZWJpdC1iYW5uZXIuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL2NvZGVidWlsZC9vdXRwdXQvc3JjNTYwNTk5NjQ0L3NyYy9zcmMvYXBwL2NvbXBsZXRlZC9lYml0LWJhbm5lci9jb21wbGV0ZWQuZWJpdC1iYW5uZXIuY29tcG9uZW50LnRzIiwibmc6Ly8vY29kZWJ1aWxkL291dHB1dC9zcmM1NjA1OTk2NDQvc3JjL3NyYy9hcHAvY29tcGxldGVkL2ViaXQtYmFubmVyL2NvbXBsZXRlZC5lYml0LWJhbm5lci5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2NvZGVidWlsZC9vdXRwdXQvc3JjNTYwNTk5NjQ0L3NyYy9zcmMvYXBwL2NvbXBsZXRlZC9lYml0LWJhbm5lci9jb21wbGV0ZWQuZWJpdC1iYW5uZXIuY29tcG9uZW50LnRzLkNvbXBsZXRlZEViaXRCYW5uZXJDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8YSBpZD1cImJhbm5lckViaXRcIj48L2E+XG48cGFyYW0gaWQ9XCJlYml0UGFyYW1cIiB2YWx1ZT1cInt7cGFyYW1WYWx1ZX19XCIgLz4iLCI8Y29tcGxldGVkLWViaXQtYmFubmVyPjwvY29tcGxldGVkLWViaXQtYmFubmVyPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQUE7TUFBQSx3RUFBdUI7YUFBQSwyQkFDdkI7TUFBQTtNQUFBOztJQUFzQjtJQUF0QixXQUFzQixTQUF0Qjs7OztvQkNEQTtNQUFBOzZDQUFBLFVBQUE7c0NBQUE7O1FBQUE7Ozs7OyJ9



// WEBPACK FOOTER //
// /codebuild/output/src560599644/src/src/$$_gendir/app/completed/ebit-banner/completed.ebit-banner.component.ngfactory.ts